module.exports = __webpack_public_path__ + "static/media/taylor.e5b62e4d.png";